import { render, staticRenderFns } from "./ValidationLabel.vue?vue&type=template&id=246b8e22&"
import script from "./ValidationLabel.vue?vue&type=script&lang=js&"
export * from "./ValidationLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports